import { render } from "./TermosUsoPage.vue?vue&type=template&id=480c7277&scoped=true"
import script from "./TermosUsoPage.vue?vue&type=script&lang=js"
export * from "./TermosUsoPage.vue?vue&type=script&lang=js"

import "./TermosUsoPage.vue?vue&type=style&index=0&id=480c7277&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480c7277"]])

export default __exports__